import Image from '@anm/components/image/Image';
import noop from '@anm/helpers/noop';
import { toUrlParams } from '@anm/helpers/parseParams';
import { FC } from 'react';

import Container from './Container';
import { strWindowSettings } from './helpers';
import { ShareProps } from './types';

const shareOnLinkedin = ({ url, onShare = noop }: ShareProps) => {
  const query = toUrlParams({ url, mini: true });
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite?${query}`;
  onShare('linkedIn');

  window.open(linkedinUrl, 'LinkedinWindow', strWindowSettings);
};

const LinkedinShare: FC<ShareProps> = props => (
  <Container onClick={() => shareOnLinkedin(props)}>
    <Image src="images/icons/share/linkedin-icon.svg" />
    <h5>Linkedin</h5>
  </Container>
);

export default LinkedinShare;
